import { countries, isLangSupportedForCountry } from 'config/countries';
import { languages } from 'data/languages';

const languageCodes = languages.map(language => language.code);
const fallbackLanguage = process.env.DEFAULT_LANGUAGE || 'en';

/**
 * The URL is the canonical locale source for Gatsby's generated pages.
 * Supports country routes (/tn/ar/...) and the legacy root-language pages
 * (/ar/...). Utility routes keep the configured default.
 */
export const localeFromPath = (pathname = '') => {
  const [first, second] = pathname.split('/').filter(Boolean);
  let lang = fallbackLanguage;

  if (countries[first] && isLangSupportedForCountry(first, second)) {
    lang = second;
  } else if (languageCodes.includes(first)) {
    lang = first;
  }

  return {
    lang,
    dir: languages.find(language => language.code === lang)?.dir || 'ltr'
  };
};
